import React from "react";
import { Icon } from "@ddm-design-system/icon";
import { Description, DescriptionMedium } from "@ddm-design-system/typography";
import { InspectorTooltip } from "@ddm-design-system/tooltip";
import { Divider } from "@ddm-design-system/divider";
import { IX10 } from "../../../store/installation/types";
import useX10Text from "./useX10Text";
import { x10Issues } from "./x10Presentation";

interface IProps {
  x10: IX10;
}

/** OK / Offline / Tower open, or one icon per active problem with the details in a tooltip. */
export const X10Badges: React.FC<IProps> = ({ x10 }) => {
  const t = useX10Text();

  if (x10.offline) {
    return <DescriptionMedium className="text-grey-grey100">{t("offline")}</DescriptionMedium>;
  }
  if (x10.evaluation.open) {
    return <DescriptionMedium className="text-black">{t("open")}</DescriptionMedium>;
  }

  const issues = x10Issues(x10, t);
  if (issues.length === 0) {
    return <DescriptionMedium className="text-success-success100">{t("ok")}</DescriptionMedium>;
  }

  return (
    <>
      {issues.map(issue => {
        const iconColor =
          issue.level === "danger" ? "text-alert-alert100" : "text-warning-warning100";
        return (
          <InspectorTooltip
            key={issue.key}
            title={
              <span className="flex items-center flex-start">
                <Icon
                  className={`${iconColor} border border-transparent rounded-[50%] mr-xs fill-current`}
                  name={issue.icon}
                  size={16}
                />
                <DescriptionMedium>{issue.title}</DescriptionMedium>
              </span>
            }
            renderHeader={() => (
              <Icon
                className={`${iconColor} border border-transparent rounded-[50%] fill-current`}
                name={issue.icon}
                size={24}
              />
            )}
            zIndex={90}
          >
            <>
              <Divider className="mt-sm mb-md" />
              <Description className="leading-p">{issue.description}</Description>
            </>
          </InspectorTooltip>
        );
      })}
    </>
  );
};

export default X10Badges;
